<template>
  <div class="my-history">
    <div class="my-withdraw-mobile-package">
      <div class="mobile-frame">
        <div class="channel-text-n">
          {{ $t('Bao.transaction-index') }}
        </div>

        <!-- 上方選單 -->
        <div class="mobile-frame">
          <div class="mobile-wallet-card">
            <div class="wallet-list" @click="$router.push('/deposit')">
              {{ $t('Bao.deposit') }}
            </div>
            <div class="wallet-list" @click="$router.push('/withdrawal')">
              {{ $t('Bao.withdraw_menu') }}
            </div>
            <div class="wallet-list-on">
              {{ $t('Bao.transaction-index') }}
            </div>
          </div>
          <div class="deposit-bg">
            <div class="wallet-choice" @touchstart="touchStart" @touchmove="touchMove" @touchend="touchEnd">
              <div class="angle-icon prev" @click="prevSlide">
                <img v-if="currentIndex === 0" :src="require(`@/assets/${$store.getters.currentTheme}/images/Angle-left-g.png`)" alt="">
                <img v-else :src="require(`@/assets/${$store.getters.currentTheme}/images/Angle-left.png`)" alt="">
              </div>

              <transition-group name="slide">
                <div v-for="(item, index) in visibleItems" :key="index" :class="['wallet-item', item.className, { active: type === item.index + 1 }]" @click="queryType(item.index + 1)">
                  <p>{{ item.text }}</p>
                </div>
              </transition-group>

              <div class="angle-icon next" @click="nextSlide">
                <img v-if="currentIndex >= walletItems.length - windowSize" :src="require(`@/assets/${$store.getters.currentTheme}/images/Angle-right-g.png`)" alt="">
                <img v-else :src="require(`@/assets/${$store.getters.currentTheme}/images/Angle-right.png`)" alt="">
              </div>
            </div>
          </div>
        </div>

        <div class="mobile-frame">
          <div v-if="type !== 4 && type !== 5" class="form-section-n wallet-promo">
            <select class="withdraw-option" name="" @change="handleSelectChange">
              <option :value="'all'">
                {{ $t("Bao.all") }}
              </option>
              <option
                v-for="(item, key) in transactionStatus"
                :key="key"
                :value="key"
              >
                {{ item }}
              </option>
            </select>
          </div>

          <h5 class="channel-text-n">
            {{ $t("Bao.transaction_detail") }}
          </h5>
          <div class="history-calendar-box">
            <div class="calendar-title">
              {{ $t("Bao.date") }}:
            </div>
            <div class="calendar-data">
              <datePicker v-model="dateRange" @query="oneQuery" />
            </div>
          </div>

          <div class="history-card-list">
            <div v-if="record.length === 0 && !loading && !firstLoad" class="history-card">
              <div class="history-data-none">
                <div class="data-none-img">
                  <img :src="require(`@/assets/${$store.getters.currentTheme}/images/no-data.png`)" alt="">
                </div>
                <div class="data-none-title">
                  {{ $t('Bao.no_relevant_data_records') }}
                </div>
                <div class="data-none-description">
                  {{ $t('Bao.search_results_are_empty') }}
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <scroll-loader :loader-method="query" :loader-disable="!enableAutoLoad" />
            </div>
            <template v-if="record.length !== 0">
              <div v-for="(item, key) in record" :key="key" class="history-card">
                <table class="history-date-table-m">
                  <tbody v-if="type === 1 || type === 3">
                    <tr>
                      <td class="history-title-m">
                        {{ $t("Bao.time") }}
                      </td>
                      <td class="history-data-m" :data-title="$t('Bao.time')">
                        {{ item.created_at | fullDateTimeFormat }}
                      </td>
                    </tr>
                    <tr>
                      <td class="history-title-m">
                        {{ $t("Bao.type") }}
                      </td>
                      <td class="history-data-m" :data-title="$t('Bao.type')">
                        {{ item.action_type_label }}
                      </td>
                    </tr>
                    <tr>
                      <td class="history-title-m">
                        {{ $t("Bao.amount") }}
                      </td>
                      <td class="history-data-m" :data-title="$t('Bao.amount')">
                        {{ item.amount | numberFormat }}
                      </td>
                    </tr>
                    <tr>
                      <td class="history-title-m">
                        {{ $t("Bao.tx_balance") }}
                      </td>
                      <td class="history-data-m" :data-title="$t('Bao.tx_balance')">
                        {{ item.balance | numberFormat }}
                      </td>
                    </tr>
                    <tr>
                      <td class="history-title-m">
                        {{ $t("Bao.other") }}
                      </td>
                      <td class="history-data-m" :data-title="$t('Bao.other')">
                        {{ item.action_content }}
                      </td>
                    </tr>
                    <tr>
                      <td class="history-title-m">
                        {{ $t("Bao.order_number") }}
                      </td>
                      <td class="history-data-m" :data-title="$t('Bao.order_number')">
                        {{ item.ref_id }}
                      </td>
                    </tr>
                  </tbody>

                  <tbody v-if="type === 2">
                    <tr>
                      <th>{{ $t("Bao.time") }}</th>
                      <td :data-title="$t('Bao.time')">
                        {{ item.created_at | fullDateTimeFormat }}
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t("Bao.type") }}</th>
                      <!--eslint-disable-next-line-->
                      <td :data-title="$t('Bao.type')" v-html="item.action_type_label"></td>
                    </tr>
                    <tr>
                      <th>{{ $t("Bao.amount") }}</th>
                      <td :data-title="$t('Bao.amount')">
                        {{ item.amount | numberFormat }}
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t("Bao.tx_balance") }}</th>
                      <td :data-title="$t('Bao.tx_balance')">
                        {{ item.balance | numberFormat }}
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t("Bao.order_number") }}</th>
                      <td :data-title="$t('Bao.order_number')">
                        {{ item.ref_id }}
                      </td>
                    </tr>
                  </tbody>

                  <tbody v-if="type === 4">
                    <tr>
                      <td class="history-title-m">
                        {{ $t("Bao.time") }}
                      </td>
                      <td :data-title="$t('Bao.time')" class="history-data-m">
                        {{ item.create_at | fullDateTimeFormat }}
                      </td>
                    </tr>
                    <tr>
                      <td class="history-title-m">
                        {{ $t("Bao.ref_id") }}
                      </td>
                      <td :data-title="$t('Bao.ref_id')" class="history-data-m">
                        {{ item.ref_id }}
                      </td>
                    </tr>
                    <tr>
                      <td class="history-title-m">
                        {{ $t("Bao.wallet_action") }}
                      </td>
                      <td :data-title="$t('Bao.wallet_action')" class="history-data-m">
                        {{ item.method }} {{ item.channel ? ' - ' + item.channel : '' }}
                      </td>
                    </tr>
                    <tr>
                      <td class="history-title-m">
                        {{ $t("Bao.deposit_for_record") }}
                      </td>
                      <td :data-title="$t('Bao.deposit_for_record')" class="history-data-m">
                        {{ item.request_amount | numberFormat }}
                      </td>
                    </tr>
                    <tr>
                      <td class="history-title-m">
                        {{ $t("Bao.receive") }}
                      </td>
                      <td :data-title="$t('Bao.receive')" class="history-data-m">
                        {{ item.amount | numberFormat }}
                      </td>
                    </tr>
                    <tr>
                      <td class="history-title-m">
                        {{ $t("Bao.change") }}
                      </td>
                      <td :data-title="$t('Bao.change')" class="history-data-m">
                        {{ item.exchange_rate | numberFormat }}
                      </td>
                    </tr>
                    <tr>
                      <td class="history-title-m">
                        {{ $t("Bao.status") }}
                      </td>
                      <td :data-title="$t('Bao.status')" class="history-data-m">
                        {{ item.status_label }}
                      </td>
                    </tr>
                  </tbody>

                  <tbody v-if="type === 5">
                    <tr>
                      <td class="history-title-m">
                        {{ $t("Bao.time") }}
                      </td>
                      <td :data-title="$t('Bao.time')" class="history-data-m">
                        {{ item.create_at | fullDateTimeFormat }}
                      </td>
                    </tr>
                    <tr>
                      <td class="history-title-m">
                        {{ $t("Bao.ref_id") }}
                      </td>
                      <td class="history-data-m" :data-title="$t('Bao.ref_id')">
                        {{ item.ref_id }}
                      </td>
                    </tr>
                    <tr>
                      <td class="history-title-m">
                        {{ $t("Bao.wallet_action") }}
                      </td>
                      <td :data-title="$t('Bao.wallet_action')" class="history-data-m">
                        {{ item.method }} {{ item.channel ? ' - ' + item.channel : '' }}
                      </td>
                    </tr>
                    <tr>
                      <td class="history-title-m">
                        {{ $t("Bao.withdrawal_for_record") }}
                      </td>
                      <td :data-title="$t('Bao.withdrawal_for_record')" class="history-data-m">
                        {{ item.request_amount | numberFormat }}
                      </td>
                    </tr>
                    <tr>
                      <td class="history-title-m">
                        {{ $t("Bao.receive") }}
                      </td>
                      <td :data-title="$t('Bao.receive')" class="history-data-m">
                        {{ item.real_amount | numberFormat }}
                      </td>
                    </tr>
                    <tr>
                      <td class="history-title-m">
                        {{ $t("Bao.change") }}
                      </td>
                      <td :data-title="$t('Bao.change')" class="history-data-m">
                        {{ item.exchange_rate | numberFormat }}
                      </td>
                    </tr>
                    <tr>
                      <td class="history-title-m">
                        {{ $t("Bao.status") }}
                      </td>
                      <td :data-title="$t('Bao.status')" class="history-data-m">
                        {{ item.status_label }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datePicker from '@/components/datePicker'
import moment from 'moment'
import { getCommonTransactionStatus, getBonusTransactionStatus, getCommissionTransactionStatus } from '@/api/common'
import { getMain, getBonus, getCommission } from '@/api/transaction'
import { depositRecord, withdrawalRecord } from '@/api/payment'
import ScrollLoader from 'vue-scroll-loader/src/components/Scroll-Loader'

export default {
  components: {
    datePicker,
    ScrollLoader
  },
  data() {
    return {
      currentIndex: 0,
      startX: 0,
      startY: 0,
      endX: 0,
      endY: 0,
      isClick: true,
      windowSize: 3,
      walletItems: [
        { text: this.$t('Bao.main_wallet_detail_2'), className: 'wallet-cash' },
        { text: this.$t('Bao.bonus_wallet_detail_2'), className: 'wallet-trophy' },
        { text: this.$t('Bao.commission_gold_2'), className: 'wallet-back' },
        { text: this.$t('Bao.deposit_detail'), className: 'wallet-deposit' },
        { text: this.$t('Bao.withdrawal_detail_2'), className: 'wallet-withdrawal' }
      ],
      dateRange: {
        startDate: moment().subtract(7, 'd'),
        endDate: new Date()
      },
      actionType: 'all',
      record: [],
      transactionStatus: [],
      page: 1,
      pageSize: 50,
      enableAutoLoad: false,
      loading: false,
      firstLoad: true,
      selectActionType: this.$i18n.t('Bao.all'),
      type: 1
    }
  },
  computed: {
    visibleItems() {
      return this.walletItems.slice(this.currentIndex, this.currentIndex + this.windowSize).map((item, index) => {
        return {
          ...item,
          index: this.currentIndex + index
        }
      })
    }
  },
  async created() {
    this.getCommonTransactionStatus()
    this.oneQuery()
  },
  methods: {
    prevSlide() {
      if (this.currentIndex > 0) {
        this.currentIndex -= 1
      }
    },
    nextSlide() {
      if (this.currentIndex < this.walletItems.length - this.windowSize) {
        this.currentIndex += 1
      }
    },
    touchStart(event) {
      this.startX = event.type === 'touchstart' ? event.touches[0].clientX : event.clientX
      this.startY = event.type === 'touchstart' ? event.touches[0].clientY : event.clientY
      this.isClick = true
    },
    touchMove(event) {
      this.endX = event.type === 'touchmove' ? event.touches[0].clientX : event.clientX
      this.endY = event.type === 'touchmove' ? event.touches[0].clientY : event.clientY

      // Check if the movement is primarily horizontal or vertical
      if (Math.abs(this.endX - this.startX) > 10 || Math.abs(this.endY - this.startY) > 10) {
        this.isClick = false
      }
    },
    touchEnd() {
      if (!this.isClick) {
        if (this.startX > this.endX + 50) {
          this.nextSlide()
        } else if (this.startX < this.endX - 50) {
          this.prevSlide()
        }
      }

      // Reset variables
      this.startX = 0
      this.startY = 0
      this.endX = 0
      this.endY = 0
      this.isClick = true
    },
    oneQuery() {
      this.enableAutoLoad = true
      this.page = 1
      this.record = []
      this.query()
    },
    async getCommonTransactionStatus() {
      try {
        const res = await getCommonTransactionStatus()
        this.transactionStatus = res.data.data
      } catch (error) {
        console.error('Error fetching bonus transaction status:', error)
      }
    },
    async getBonusTransactionStatus() {
      try {
        const res = await getBonusTransactionStatus()
        this.transactionStatus = res.data.data
      } catch (error) {
        console.error('Error fetching bonus transaction status:', error)
      }
    },
    async getCommissionTransactionStatus() {
      try {
        const res = await getCommissionTransactionStatus()
        this.transactionStatus = res.data.data
      } catch (error) {
        console.error('Error fetching commission transaction status:', error)
      }
    },
    queryType(index) {
      this.type = index
      this.record = []
      this.transactionStatus = []

      switch (true) {
        case index === 2:
          this.getBonusTransactionStatus()
          break
        case index === 3:
          this.getCommissionTransactionStatus()
          break
        default:
          this.getCommonTransactionStatus()
      }

      this.query()
    },
    async query() {
      if (this.loading) return
      this.loading = true
      this.firstLoad = false
      const queryObj = {
        'startDate': moment(this.dateRange.startDate).format('YYYY/MM/DD'),
        'endDate': moment(this.dateRange.endDate).format('YYYY/MM/DD'),
        'page': this.page,
        'page_size': this.pageSize
      }
      if (this.actionType !== 'all') {
        queryObj.action_type = this.actionType
      }

      let res = []

      switch (true) {
        case this.type === 2:
          res = await getBonus(queryObj)
          break

        case this.type === 3:
          res = await getCommission(queryObj)
          break

        case this.type === 4:
          res = await depositRecord(queryObj)
          break

        case this.type === 5:
          res = await withdrawalRecord(queryObj)
          break

        default:
          res = await getMain(queryObj)
      }

      if (res && res.data && res.data.data && res.data.data.list) {
        this.record = [...this.record, ...res.data.data.list]
        if (res.data.data.list.length < this.pageSize) {
          this.enableAutoLoad = false
        } else {
          this.enableAutoLoad = true
          this.page += 1
        }
      }

      this.loading = false
      this.firstLoad = false
    },
    handleSelectChange(event) {
      const selectedKey = event.target.value
      const actionType = this.transactionStatus[selectedKey]
      this.clickQuery(selectedKey, actionType)
    },
    clickQuery(actionType, actionTypeName) {
      this.actionType = actionType
      if (actionType === 'all') {
        this.selectActionType = this.$i18n.t('Bao.all')
      } else {
        this.selectActionType = actionTypeName
      }
      window.scrollTo(0, 0)
      this.enableAutoLoad = true
      this.page = 1
      this.record = []
      this.query()
    }
  }
}
</script>

<style scoped>
.wallet-choice {
  position: relative;
}

.prev {
  left: 0;
}

.next {
  right: 0;
}

@media (max-width: 450px){
  .history-calendar-box {
    flex-flow: nowrap;
  }

  .calendar-title {
    width: 50px;
  }
}

</style>
